<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card class="box">
        <v-simple-table class="simple-table">
          <thead>
            <th>Event Name</th>
            <th>Event Description</th>
            <th>From</th>
            <th>To</th>
          </thead>
          <tbody>
            <tr>
              <td>{{ selectedEvent.name }}</td>
              <td>{{ selectedEvent.description }}</td>
              <td>{{ selectedEvent.from_date_time }}</td>
              <td>{{ selectedEvent.end_date_time }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
      <v-card class="box">
        <v-toolbar flat class="toolbar" dense>
          <v-toolbar-title>Booking Overview</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-row dense justify="end">
          <v-col cols="12" sm="2" md="2" class="mr-7 ml-5">
            <b>Stream</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete
              dense
              v-model="stream"
              :items="stream_list"
              @click="getStreamData"
              item-text="name"
              item-value="id"
              name="Stream"
              outlined
              persistent-hint
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" class="mr-7">
            <b>Standard</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete
              dense
              v-model="std"
              :items="standard_list"
              @change="getStandard()"
              item-text="standard"
              item-value="id"
              name="Standard"
              outlined
              persistent-hint
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" class="mr-7">
            <b>Division</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete
              dense
              v-model="div"
              :items="dision_list"
              item-text="div_name"
              item-value="div_off_id"
              name="Division"
              return-object
              outlined
              persistent-hint
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <b>Booking Status</b
            ><v-icon class="pl-1 pb-3" color="error">*</v-icon>
            <v-autocomplete
              dense
              v-model="bookingStatus"
              :items="event_booking_status_list"
              item-text="name"
              item-value="id"
              name="Booking Status"
              return-object
              outlined
              persistent-hint
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" align-self="center" class="ml-8">
            <v-btn class="button">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="12" sm="12" md="12" align="center">
            <v-btn class="info" @click="addSlot">Add Slot</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog v-model="dialog" max-width="900">
        <v-card>
          <v-card-title style="background-color: lightgrey">
            <v-icon class="mr-2">mdi-calendar</v-icon>
            Add Slot
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="4" md="4">
                <b>Event</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                <v-text-field
                  readonly
                  label="Event"
                  filled
                  dense
                  v-model="selectedEvent.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <b>Teacher</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                <v-autocomplete
                  dense
                  v-model="teacher"
                  :items="instructor_list"
                  item-text="name"
                  item-value="id"
                  name="Teacher"
                  outlined
                  hint="Please select the event"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <b>Slot Name</b
                ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                <v-text-field
                  label="Slot Name"
                  v-model="slotName"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="4" md="4" align="center">
                <b>Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                ><br />
                <input type="date" v-model="date" id="date" name="date" />
              </v-col>
              <v-col cols="12" sm="4" md="4" align="center">
                <b>From Time</b
                ><v-icon class="pl-1 pb-2" color="error">*</v-icon><br />
                <input type="time" v-model="FromTime" id="time" name="time" />
              </v-col>
              <v-col cols="12" sm="4" md="4" align="center">
                <b>To Time</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                ><br />
                <input type="time" v-model="ToTime" id="time2" name="time" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" md="4" class="pb-0">
                <v-checkbox
                  v-model="IsOnline"
                  color="success"
                  style="margin-top: 45px"
                  label="Is Online Meeting ?"
                  @change="showMsg"
                  ><b></b
                ></v-checkbox>
              </v-col>
              <v-col v-if="showLink" cols="12" sm="7" md="7" class="ml-8">
                <v-text-field
                  v-model="meeting_link"
                  label="Meeting Link"
                  style="margin-bottom: -15px; margin-top: 45px"
                  readonly
                  filled
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" md="4" class="pb-0">
                <v-checkbox
                  v-model="IsCommon"
                  color="success"
                  style="margin-top: 23px"
                  label="Is Common Slot ?"
                  ><b></b
                ></v-checkbox>
              </v-col>
              <v-spacer></v-spacer>
              <v-col v-if="!IsCommon" cols="12" sm="6" md="6" class="">
                <b style="">Applicable To</b> <br />
                <v-row>
                  <v-col cols="12" sm="6" md="6" style="margin-left: -24px">
                    <v-autocomplete
                      dense
                      v-model="standard"
                      :items="standard_list_all"
                      item-text="standard"
                      item-value="id"
                      name="Standard"
                      outlined
                      multiple
                      @change="get_divisions_stream(standard, 'standard')"
                      hint="Standard"
                      persistent-hint
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-if="division_list != ''">
                    <v-autocomplete
                      dense
                      v-model="div"
                      item-text="divname"
                      item-value="id"
                      name="Division"
                      :items="division_list"
                      multiple
                      outlined
                      hint="Division"
                      persistent-hint
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="plain" large class="mr-4" @click="close">Close</v-btn>
            <v-btn color="primary" large variant="tonal" @click="saveSlotDetails"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="box">
        <v-data-table :headers="headers" :items="event_time_slot_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Slot Booking Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:item.applicable_details="{ item }">
            <v-icon
              v-if="item.applicable_details.length > 0"
              @click="openApplicableToDialog(item.applicable_details)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            >
            <span v-else>--</span>
          </template>
          <template v-slot:item.student="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.learner_name
                }}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.parent="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.booked_by
                }}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.slot_type="{ item }">
            <span v-if="item.meeting_link">Online</span>
            <span v-else>Offline</span>
          </template>
          <template v-slot:item.action="{ item }">
            <span v-if="item.event_status == 'Booked'"
              ><v-btn
                small
                class="button"
                @click="cancelSlotBooking(item)"
                color="error"
                >Cancel slot booking</v-btn
              ></span
            >
            <span v-else-if="item.event_status == 'Available'"
              ><v-btn
                small
                class="button"
                @click="proceedSlotBooking(item)"
                color="primary"
                >Proceed for slot booking</v-btn
              ></span
            >
          </template>
          <template v-slot:item.meeting_link="{ item }">
            <v-icon
              v-if="item.meeting_link"
              @click="openLinkDialog(item.meeting_link)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            >
            <span v-else>--</span>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="applicableTodialog" max-width="400">
        <v-card>
          <v-card-title>Slot Applicable To</v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead style="background-color: lightgrey">
                <th>Standard</th>
                <th>Division</th>
              </thead>
              <tbody>
                <tr v-for="(details, index) in slotAppliedTo" :key="index">
                  <td>{{ details.standard_name }}</td>
                  <td>{{ details.division_name }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="applicableTodialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLink" max-width="600">
        <v-card>
          <v-card-title class="">Meeting Link</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="selectedMeetingLink"
              label="Meeting Link"
              readonly
              outlined
              append-outer-icon="mdi-content-copy"
              @click:append-outer="copyLink(selectedMeetingLink)"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogLink = false;">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="ProceedSlotDialog" fullscreen persistent>
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong>Proceed Slot Booking </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="CloseDialog"
              ><v-icon> mdi-close </v-icon></v-btn
            >
          </v-toolbar>
          <v-row justify="center">
            <v-col cols="12" sm="3" md="3" class="mt-2">
              <b>Event</b>
              <v-text-field
                label="Name"
                class="pt-2"
                outlined
                dense
                readonly
                filled
                v-model="selectedEvent.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="mt-2">
              <b>Teacher</b>
              <v-text-field
                label="Teacher"
                outlined
                dense
                readonly
                class="pt-2"
                filled
                v-model="selTeacher"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <b>Child</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
              <v-autocomplete
                dense
                v-model="child"
                :items="learner_list"
                item-text="name"
                item-value="lid"
                name="Child"
                rounded
                outlined
                hint="Please select child"
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="pt-0" align="center">
              <v-btn v-model="fetch" class="button" @click="getStudentData"
                >Fetch</v-btn
              >
            </v-col>
          </v-row>
          <v-simple-table v-if="fetch" class="table2">
            <thead>
              <th>Student</th>
              <th>Event Name</th>
              <th>Standard</th>
              <th>Division</th>
              <th>Teacher Name</th>
              <th>Subject Name</th>
            </thead>
            <tbody>
              <tr v-for="item in learner_info" :key="item.id">
                <td>{{ item.learner }}</td>
                <td>{{ item.event_name }}</td>
                <td>{{ item.standard }}</td>
                <td>{{ item.division }}</td>
                <td>{{ item.teacher }}</td>
                <td>{{ item.subject }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <!-- <v-row justify="center">
              <v-btn class="button" @click="cancelSlotDialog = false">Cancel</v-btn>
          </v-row> -->
          <v-data-table
          v-if="fetch"
            :headers="headers2"
            :items="available_event_time_slot_list"
            dense
            class="elevation-1 mt-9 mytable"
          >
            <template v-slot:top>
              <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Available Slot Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <span
                ><v-btn small class="button" color="success" @click="book(item)">Book</v-btn></span
              >
            </template>
            <template v-slot:item.slot_type="{ item }">
            <span v-if="item.meeting_link">Online</span>
            <span v-else>Offline</span>
          </template>
          <template v-slot:item.meeting_link="{ item }">
            <v-icon
              v-if="item.meeting_link"
              @click="openLinkDialog(item.meeting_link)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            >
            <span v-else>--</span>
          </template>
          </v-data-table>
          <br /><br />
          <v-data-table v-if="fetch" :headers="headers3" :items="booked_event_time_slot_list" dense class="elevation-1 mytable">
            <template v-slot:top>
              <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Booked Slot Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    headers: [
      { text: "Event Name", value: "name" },
      { text: "Event Description", value: "desc" },
      { text: "From", value: "from_date_time" },
      { text: "To", value: "end_date_time" },
    ],
    studentTable: [],
    headers: [
      { text: "Sr.No.", value: "srno" },
      { text: "Slot Applicable To", value: "applicable_details" },
      { text: "Teacher Name", value: "slotfor" },
      { text: "Slot Name", value: "name" },
      { text: "From", value: "from_date_time" },
      { text: "To", value: "end_date_time" },
      { text: "Slot Type", value: "slot_type" },
      { text: "Meeting link", value: "meeting_link" },
      { text: "Slot status", value: "event_status" },
      { text: "Student", value: "student" },
      { text: "Parent", value: "parent" },
      { text: "Added By", value: "addedby" },
      { text: "Action", value: "action" },
    ],
    headers2: [
      { text: "Sr.No.", value: "srno" },
      { text: "Slot Name", value: "name" },
      { text: "From", value: "from_date_time" },
      { text: "To", value: "end_date_time" },
      { text: "Slot Type", value: "slot_type" },
      { text: "Meeting link", value: "meeting_link" },
      { text: "Action", value: "action" },
    ],
    headers3: [
      { text: "Sr.No.", value: "srno" },
      { text: "Slot Name", value: "name" },
      { text: "From", value: "from_date_time" },
      { text: "To", value: "end_date_time" },
    ],
    event_time_slot_list: [],
    dialog: false,
    IsOnline: false,
    IsCommon: false,
    slotName: "",
    date: new Date().toISOString().substr(0, 10),
    FromTime: new Date().toTimeString().substr(0, 5),
    ToTime: new Date().toTimeString().substr(0, 5),
    teacher: null,
    std: "",
    div: "",
    standard:"",
    cancelSlotDialog: false,
    ProceedSlotDialog: false,
    event: "",
    child: "",
    sel_teacher: "",
    fetch: false,
    instructor_list: [],
    event_booking_status_list: [],
    stream_list: null,
    selectedEvent: [],
    bookingStatus: "",
    stream: null,
    standard_list: null,
    dision_list: [],
    showLink: false,
    meeting_link: "",
    ay_id: null,
    standard_list_all: [],
    division_list: [],
    dialogLink: false,
    selectedMeetingLink: "",
    available_event_time_slot_list: [],
    booked_event_time_slot_list: [],
    learner_info: [],
    applicableTodialog: false,
    slotAppliedTo: [],
    selTeacher: "",
    learner_list: [],
    eventSlot_id: null,
    instructorId: null,
    selChild: null,
  }),
  computed: {},
  methods: {
    proceedSlotBooking(item){
      this.ProceedSlotDialog = true;
      this.selTeacher = item.slotfor;
      this.eventSlot_id = item.id;
      this.selChild = item.bookings.length > 0 ? item.bookings[0].id : null;
      this.instructorId = item.slotfor_id;
    },
    openLinkDialog(link) {
      this.selectedMeetingLink = link;
      this.dialogLink = true;
    },
    book(item){
        if (!confirm("Are you sure you want to book this slot: " + item.name + " from " + item.from_date_time + " to " + item.end_date_time + "?")) return;

        const data = {
        event_slot_id : item.id,
        parent_id: this.learner_info[0].parent_id,
        student_id: this.learner_info[0].learner_id,
        learnerDivision_id : this.learner_info[0].learnerDivision_id,
      };
      console.log(data);
      axios
        .post("Appointment/bookEventSlotForStudent", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("success", "Slot booked successfully");
            // this.event_time_slot_list = res.data.event_time_slot_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          
        });
    },
    copyLink(link) {
      navigator.clipboard.writeText(link).then(
        () => {
          this.showSnackbar("success", "Link copied to clipboard!");
        },
        () => {
          this.showSnackbar("error", "Failed to copy link");
        }
      );
    },
    getStreamData() {
      const data = {
        ay: this.ay_id,
        stream: this.stream,
      };
      axios
        .post("/InstallmentStructureDetails/getStreamData", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "No division for this stream / Stream mapping not done for selected stream!!!"
            ); // show snackbar on error
            this.show = false;
            return;
          }
          if (res.data.flag == "YES") {
            this.show = true;
            this.dision_list = res.data.dision_list;
            this.standard_list = res.data.standard_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    close() {
      this.dialog = false;
      this.resetform();
    },
    getStandard() {
      const data = {
        ay: this.ay_id,
        std: this.std,
        stream: this.stream,
      };
      axios
        .post("/InstallmentStructureDetails/getStandard", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.dision_list = res.data.dision_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    get_divisions_stream(standard, type) {
      if (type == "standard") {
        const formData = {
          ay: this.ay_id,
          standard: standard,
        };
        axios
          .post("/Communication/get_standard_divisions", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.division_list = res.data.division_list;
              this.new_div_ids = res.data.applicable_to_div_ids;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            // this.stream = "";
          });
      }
    },
    openApplicableToDialog(set) {
      this.applicableTodialog = true;
      this.slotAppliedTo = set;
    },
    saveSlotDetails() {
      if (
        this.date == "" || this.FromTime == "" || this.ToTime == "" || this.slotName.trim() == "" || this.teacher == "") {
        this.showSnackbar("error", "Please fill all required fields");
        return;
      }
      if(this.IsCommon == false && this.standard == '' && this.div == '')
      {
        this.showSnackbar("error","Either check 'Is common slot' or select standard/s and division/s");
        return;
      }
      const data = {
        event_id: this.selectedEvent.id,
        date: this.date,
        from_time: this.FromTime,
        to_time: this.ToTime,
        standard: this.IsCommon ? null : this.standard,
        div: this.IsCommon ? null : this.div,
        meeting_link: this.IsOnline ? this.meeting_link : null,
        iscommonslot: this.IsCommon,
        name: this.slotName,
        instructor: this.teacher,
      };
      axios
        .post("Appointment/saveTeacherEventSlot", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("success", "Saved successfully");
            // this.event_time_slot_list = res.data.event_time_slot_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.dialog = false;
          this.resetform();
          this.getEventDetails();
        });
    },
    getEventDetails() {
      // console.log(this.selectedEvent);
      // console.log(this.selectedEvent.name);
      // console.log(this.selectedEvent.id);
      const data = {
        event_id: this.selectedEvent.id,
      };
      axios
        .post("Appointment/getEventDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.event_time_slot_list = res.data.event_time_slot_list;
            this.instructor_list = res.data.instructor_list;
            this.event_booking_status_list = res.data.event_booking_status_list;
            this.stream_list = res.data.stream_list;
            this.standard_list_all = res.data.standard_list_all;
            this.learner_list = res.data.learner_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {});
    },
    showMsg() {
      if (this.IsOnline) {
        if (this.meeting_link === null) {
          this.showSnackbar("error", "Please add new meeting link");
          this.showLink = false;
        } else {
          this.showLink = true;
        }
      } else {
        this.showLink = false;
      }
    },
    resetform() {
      this.slotName = "";
      this.date = new Date().toISOString().substr(0, 10);
      this.FromTime = new Date().toTimeString().substr(0, 5);
      this.ToTime = new Date().toTimeString().substr(0, 5);
      this.IsOnline = false;
      this.IsCommon = "";
      this.std = "";
      this.div = "";
      this.showLink = false;
      this.teacher = "";
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    addSlot() {
      this.dialog = true;
    },
    cancelSlotBooking(item) {
      if (!confirm("Are you sure you want to delete this slot ?")) return;
      const data = {
        event_slot_id: item.id,
        booking_id : item.bookings.length > 0 ? item.bookings[0].id : null,
      }
      axios
        .post("Appointment/deleteEventSlot", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("success", "Slot deleted successfully");
            this.event_time_slot_list = res.data.event_time_slot_list; // empty list
            this.getEventDetails();   
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          
        });
    },
    getStudentData() {
      if(this.child == ''){
        this.showSnackbar("error","Please select child");
        return;
      }
      this.ProceedSlotDialog = true;
      this.fetch = true;
      
      const data = {
        event_slot_id: this.eventSlot_id,
        instructor: this.instructorId,
        child: this.child, 
      };
      axios
        .post("Appointment/proceedStudentEventBooking", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showSnackbar("success", "fetched successfully");
            this.event_time_slot_list = res.data.event_time_slot_list;
            this.booked_event_time_slot_list = res.data.booked_event_time_slot_list;
            this.available_event_time_slot_list = res.data.available_event_time_slot_list;
            this.learner_info = res.data.learner_info;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.dialog = false;
          this.resetform();
        });
    },
    CloseDialog() {
      this.ProceedSlotDialog = false;
      this.getEventDetails();
      this.child = "";
      this.fetch = false;
    },
  },
  mounted() {
    this.selectedEvent = JSON.parse(localStorage.getItem("selected-event"));
    this.ay_id = localStorage.getItem("ay_id");
    this.getEventDetails();
  },
  watch: {
    teacher(newTeacherId) {
      const selectedTeacher = this.instructor_list.find(
        (instructor) => instructor.id === newTeacherId
      );
      if (selectedTeacher && this.IsOnline) {
        this.meeting_link = selectedTeacher.meeting_link || "";
      } else {
        this.meeting_link = "";
      }
    },
    IsOnline(checked) {
      if (checked && this.teacher) {
        const selectedTeacher = this.instructor_list.find(
          (instructor) => instructor.id === this.teacher
        );
        this.meeting_link = selectedTeacher ? selectedTeacher.meeting_link : "";
        this.showLink = true;
      } else {
        this.meeting_link = "";
        this.showLink = false;
      }
    },
  },
};
</script>
<style scoped>
.simple-table th {
  font-size: 15px;
}
.simple-table tr {
  background-color: #eceff1;
}
.simple-table td,
.simple-table th {
  border: 1px solid black;
}
.table2 {
  width: 80%;
  margin: auto;
  border: 1px solid grey;
}
.table2 td,
.table2 th {
  border: 1px solid grey;
}
.table2 th {
  background-color: #eceff1;
}
.mytable {
  width: 97%;
  margin: auto;
}
</style>